<fury-page-layout-header>
  <fury-container class="header">
    <a href="{{ environment.homepage_url }}">
      <img alt="Milieu Klachten Centrale" src="assets/img/logo.svg">
    </a>
  </fury-container>
</fury-page-layout-header>
